module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dropdown more">\n    <a href="#" class="dropdown-toggle" data-toggle="dropdown"><span class="unread-comments-indicator"></span></a>\n\n    <ul class="dropdown-menu more-dropdown-menu">\n        <li><a href="#" class="share menu-item">Share</a></li>\n        <li><a href="#" class="toggle-comments menu-item"><span class="unread-comments-indicator"></span>Show/hide Comments</a></li>\n        <li><a href="#" class="add-comment menu-item">Add Comment</a></li>\n    </ul>\n</div>\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/editorMoreMenu/EditorMoreMenuView.tpl
// module id = 2917
// module chunks = 0